define("analytics-resources/utils/math/sort-by-x-values", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = sortByXValues;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  function sortByXValues(chartData) {
    return chartData?.sortBy('0');
  }
});